module.exports = __webpack_public_path__ + "img/img5.8bb82627.jpg";